module.exports = __webpack_public_path__ + "img/disciplinas_cursadas.5c10621c.svg";